import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";
import { handleRetriveError } from "../utils";

interface TaxClassState {
    results: any[];
}


const initialState: TaxClassState = {
    results: [],
};


const taxClassSlice = createSlice({
    name: "taxClass",
    initialState,
    reducers: {
        setTaxClass(state, action) {
            state.results = action.payload;
        },
    },
});

export const { setTaxClass } = taxClassSlice.actions;

export const fetchTaxClass = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response = await api.getTaxClass();
        dispatch(setTaxClass(response));
    } catch (error) {
        handleRetriveError(error);
    }
};

export default taxClassSlice.reducer;
